import React from 'react';

const Tree = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100'
      className='icon'
      version='1.1'
      viewBox='0 0 120 120'
    >
      <g>
        <path
          fill='#003f12'
          fillOpacity='0.941'
          stroke='none'
          strokeOpacity='1'
          strokeWidth='0.223'
          d='M57.647 1.031l-15.46 17.715-15.46 17.715 6.967.043-16.221 16.82 9.752.055L8.45 70.23l10.9.052L1.05 88.115l41.866.219v30.756h28.472V88.482l41.626.218-17.762-18.052 10.967.053-18.144-16.984 9.215.05L81.6 36.799l6.008.037-14.98-17.902z'
        ></path>
      </g>
    </svg>
  );
};

export default Tree;
